// extracted by mini-css-extract-plugin
module.exports = {"section":"_70ddd9fe","content":"_e82a841e"};